/**
 * ðŸ“Š KPIHeader â€” Excelência Module
 *
 * 4 KPI cards no padrão visual do Radar Operacional (Home):
 *  1. Blueprints Totais
 *  2. Publicados
 *  3. Rascunhos
 *  4. Usados em Projetos
 *
 * Grid responsivo: 4 col desktop / 2 tablet / 1 mobile.
 * Mesmo padrão visual dos cards do Radar.
 */

import React from 'react';
import {
  Layers,
  CheckCircle2,
  FileEdit,
  FolderOpen,
  Award,
} from 'lucide-react';

interface KPIHeaderProps {
  total: number;
  published: number;
  drafts: number;
  standards: number;
  usedInProjects: number;
  isLoading: boolean;
}

export const KPIHeader: React.FC<KPIHeaderProps> = React.memo(
  ({ total, published, drafts, standards, usedInProjects, isLoading }) => {
    if (isLoading) {
      return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 animate-pulse">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded p-6 h-[120px]"
            />
          ))}
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        {/* Blueprints Totais */}
        <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-3">
            <div className="w-10 h-10 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center">
              <Layers size={20} className="text-purple-600 dark:text-purple-400" />
            </div>
            <span className="text-xs font-semibold text-purple-600 dark:text-purple-400">Total</span>
          </div>
          <div className="text-4xl font-bold text-gray-900 dark:text-slate-100 mb-1">{total}</div>
          <div className="text-sm text-gray-500 dark:text-slate-400">Blueprints Totais</div>
        </div>

        {/* Publicados */}
        <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-3">
            <div className="w-10 h-10 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
              <CheckCircle2 size={20} className="text-emerald-600 dark:text-emerald-400" />
            </div>
            <span className="text-xs font-semibold text-emerald-600 dark:text-emerald-400">Ativo</span>
          </div>
          <div className="text-4xl font-bold text-gray-900 dark:text-slate-100 mb-1">{published}</div>
          <div className="text-sm text-gray-500 dark:text-slate-400">Publicados</div>
        </div>

        {/* Padrões Corporativos */}
        <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-3">
            <div className="w-10 h-10 rounded-full bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center">
              <Award size={20} className="text-amber-600 dark:text-amber-400" />
            </div>
            <span className="text-xs font-semibold text-amber-600 dark:text-amber-400">Padrão</span>
          </div>
          <div className="text-4xl font-bold text-gray-900 dark:text-slate-100 mb-1">{standards}</div>
          <div className="text-sm text-gray-500 dark:text-slate-400">Padrões Corporativos</div>
        </div>

        {/* Rascunhos */}
        <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-3">
            <div className="w-10 h-10 rounded-full bg-gray-100 dark:bg-slate-800 flex items-center justify-center">
              <FileEdit size={20} className="text-gray-600 dark:text-slate-400" />
            </div>
            <span className="text-xs font-semibold text-gray-600 dark:text-slate-400">Draft</span>
          </div>
          <div className="text-4xl font-bold text-gray-900 dark:text-slate-100 mb-1">{drafts}</div>
          <div className="text-sm text-gray-500 dark:text-slate-400">Rascunhos</div>
        </div>

        {/* Usados em Projetos */}
        <div className="bg-white dark:bg-slate-900 border border-gray-200 dark:border-slate-800 rounded p-6 hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-3">
            <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
              <FolderOpen size={20} className="text-blue-600 dark:text-blue-400" />
            </div>
            <span className="text-xs font-semibold text-blue-600 dark:text-blue-400">Em Uso</span>
          </div>
          <div className="text-4xl font-bold text-gray-900 dark:text-slate-100 mb-1">{usedInProjects}</div>
          <div className="text-sm text-gray-500 dark:text-slate-400">Usados em Projetos</div>
        </div>
      </div>
    );
  },
);

KPIHeader.displayName = 'KPIHeader';
